import React from 'react';

function NoServices({ labels, serviceDetailsCss }) {
  return (
    <div className={`mma--year-error ${serviceDetailsCss['service-detail-box']}`}>
      <div className='col-12'>
        <div className={`row mb-16 ${serviceDetailsCss['tru-mma-main-content-box']}`}>
          <div className={`col-12 ${serviceDetailsCss['gfw-3']} ${serviceDetailsCss['text-center']} ${serviceDetailsCss['text-md-left']} ${serviceDetailsCss['tru-mma-main-content']}`}>
            <div className='align-items-center row'>
              <div className='col-md-2'>
                <img src='/images/MyAccount/Icons/error-notification-icon.png' className='img-fluid' alt='Error Notification' />
              </div>
              <div className='col-md-10'>
                <span className={`d-block ${serviceDetailsCss['gfs-24']} ${serviceDetailsCss['gfs-lg-30']} glh-1_2 ${serviceDetailsCss['mb-10']}`}>
                  {labels.noSrvctext}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoServices;